import GlassCard from '../ui/glass/components/GlassCard';

import React, { useState, useMemo } from 'react';
import ServiceFormModal from '../components/modals/ServiceFormModal';
import { db } from '../firebase';
// writeBatch'i import ediyoruz. Bu, birden çok yazma işlemini tek seferde yapmamızı sağlar.
import { collection, addDoc, serverTimestamp, doc, deleteDoc, updateDoc, writeBatch } from 'firebase/firestore';
import useCachedCollection from '../hooks/useCachedCollection';
import { defaultServices } from '../data/defaultServices'; // Varsayılan hizmetler listemizi import ediyoruz

// MUI Bileşenleri
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Alert, AlertTitle } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import PageHeader from '../components/common/PageHeader';
import { Loading } from '../components/common/Loading';


const Hizmetler = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingService, setEditingService] = useState(null);

  // Hizmetler paylaşımlı oturum cache'inden gelir (malzeme/hizmet seçicisiyle aynı
  // cache). Yazma işlemlerinden sonra refreshServices() ile liste tazelenir.
  const { data: servicesRaw, loading, refresh: refreshServices } = useCachedCollection('services');

  const services = useMemo(
    () => [...servicesRaw].sort((a, b) => (a.hizmetAdi || '').localeCompare(b.hizmetAdi || '', 'tr')),
    [servicesRaw]
  );

  const handleSaveService = async (serviceData) => {
    try {
      if (editingService) {
        await updateDoc(doc(db, 'services', editingService.id), serviceData);
        await refreshServices();
        alert("Hizmet başarıyla güncellendi.");
      } else {
        await addDoc(collection(db, "services"), { ...serviceData, eklenmeTarihi: serverTimestamp() });
        await refreshServices();
        alert("Hizmet başarıyla eklendi!");
      }
    } catch (e) { console.error("Hata: ", e); }
  };

  const handleDeleteService = async (id, ad) => {
    if (window.confirm(`'${ad}' hizmetini silmek istediğinizden emin misiniz?`)) {
      try {
        await deleteDoc(doc(db, 'services', id));
        await refreshServices();
        alert("Hizmet silindi.");
      }
      catch (e) { console.error("Silme hatası: ", e); }
    }
  };

  // === GÜNCELLENDİ: Varsayılan Hizmetleri Toplu Ekleme Fonksiyonu ===
  const handleSeedServices = async () => {
    if (window.confirm('Varsayılan medikal hizmet listesini eklemek istediğinizden emin misiniz? Bu işlem mevcut hizmetlerinizi etkilemez.')) {
      try {
        const batch = writeBatch(db); // Bir toplu yazma işlemi başlat
        const servicesRef = collection(db, "services");

        defaultServices.forEach(service => {
          const docRef = doc(servicesRef); // Her hizmet için yeni bir belge referansı oluştur
          batch.set(docRef, {
            ...service,
            eklenmeTarihi: serverTimestamp()
          });
        });

        await batch.commit(); // Tüm işlemleri tek seferde veritabanına gönder
        await refreshServices();
        alert('Varsayılan hizmetler başarıyla eklendi!');
      } catch (e) {
        console.error("Hizmetler eklenirken hata oluştu: ", e);
        alert("Bir hata oluştu, hizmetler eklenemedi.");
      }
    }
  };

  const openModal = (service = null) => {
    setEditingService(service);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditingService(null);
  };

  return (
    <Box sx={{ p: { xs: 1, md: 1 } }}>
      <PageHeader
        title="Hizmet Yönetimi"
        subtitle="Sistem genelinde sunulan tüm hizmet ve ürünler."
        icon={<DesignServicesIcon />}
      >
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => openModal()}>Yeni Hizmet Ekle</Button>
      </PageHeader>

      <GlassCard sx={{ width: '100%', overflow: 'hidden', p: 0 }}>
        <TableContainer>
          {loading ? (<Loading message="Hizmetler yükleniyor..." />)
            : services.length > 0 ? (
              <Table stickyHeader>
                <TableHead><TableRow><TableCell>Hizmet Adı</TableCell><TableCell>Açıklama</TableCell><TableCell align="right">Fiyat</TableCell><TableCell>İşlemler</TableCell></TableRow></TableHead>
                <TableBody>
                  {services.map((service) => (
                    <TableRow hover key={service.id}>
                      <TableCell component="th" scope="row">{service.hizmetAdi}</TableCell>
                      <TableCell>{service.aciklama}</TableCell>
                      <TableCell align="right">{service.fiyat.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</TableCell>
                      <TableCell>
                        <Button size="small" variant="outlined" startIcon={<EditIcon />} sx={{ mr: 1 }} onClick={() => openModal(service)}>Düzenle</Button>
                        <Button size="small" variant="outlined" color="error" startIcon={<DeleteIcon />} onClick={() => handleDeleteService(service.id, service.hizmetAdi)}>Sil</Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : (
              <Box sx={{ p: 3, textAlign: 'center' }}>
                <Alert severity="info" variant="outlined">
                  <AlertTitle>Bilgi</AlertTitle>
                  Henüz kayıtlı hizmet bulunmamaktadır.
                </Alert>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<AutoAwesomeIcon />}
                  onClick={handleSeedServices}
                  sx={{ mt: 2 }}
                >
                  Varsayılan Medikal Hizmetlerini Ekle
                </Button>
              </Box>
            )}
        </TableContainer>
      </GlassCard>
      <ServiceFormModal isOpen={isModalOpen} onClose={closeModal} onSave={handleSaveService} serviceToEdit={editingService} />
    </Box>
  );
};

export default Hizmetler;